<div class="offer-details-container">
    <div class="nova-toolbar__pre-header space-between items-center">
        <div class="flex-row justify-start items-center">
            <div class="title">Offer Details - {{ offerDetails?.candidateName }}</div>
        </div>
        <div class="button-actions">
            <button type="submit" [disabled]="detailsFormGroup.invalid || disableSubmitAndCancel || (isJobExtension && !isJobApproved)"
                class="mat-raised-button mat-primary" color="primary"
                (click)="createOffer()" data-qa-id="CreateOfferButton">Create Offer</button>
            <button type="button" class="mat-raised-button mat-secondary" color="secondary" (click)="cancelCreateOffer()"
                [disabled]="disableSubmitAndCancel">Cancel</button>
        </div>
    </div>
    <ng-container>
        <nova-banner *ngIf="validateCandidateProfessionJobs" bannerType="alert"
            bannerMessage="Clinician's profession must match the job's profession. Please review and update before creating an Offer.">
        </nova-banner>
    </ng-container>
    <nova-banner *ngIf="isJobExtension && !isJobApproved" bannerType="alert"
        bannerMessage="Offer cannot be created because this job has not been approved by the client.">
    </nova-banner>
    <div class="offer-details-content flex-row-wrap justify-start gap-16">
        <mat-card class="info">
            <ng-template #loading>
                <div class="progress">
                    <mat-progress-spinner mode="indeterminate" diameter="96"></mat-progress-spinner>
                </div>
            </ng-template>
            <form [formGroup]="detailsFormGroup" *ngIf="offerDetails; else loading">

                <table class="offer-info-table" aria-label="Submittal Table">
                    <tbody>
                        <tr class="hidden">
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                        <tr>
                            <td><span class="label-text">Candidate *</span></td>
                            <td>
                                <span data-qa-id="CandidateView">{{ offerDetails.candidateName }}</span>
                            </td>
                        </tr>
                        <tr *ngIf="offerType === offerTypes.Agency">
                            <td><span class="label-text">Vendor</span></td>
                            <td>
                                <span data-qa-id="VendorNameView">{{ offerDetails?.vendorName }}</span>
                            </td>
                        </tr>
                        <tr *ngIf="offerType === offerTypes.Agency">
                            <td><span class="label-text">Vendor Contact</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                    <mat-select formControlName="vendorContactId" data-qa-id="VendorContactSelect">
                                        <mat-option *ngFor="let option of vendorLookups?.contacts" [value]="option.id">{{ option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Contract Type</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                    <mat-select formControlName="contractTypeId" data-qa-id="ContractTypeSelect">
                                        <mat-option *ngFor="let option of lookups?.contracts" [value]="option.id">{{ option.code }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Position Type</span></td>
                            <td>
                                <span>{{ offerDetails?.positionType }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Job ID</span></td>
                            <td>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="jobId" [matAutocomplete]="jobIdAuto" data-qa-id="JobIdInput" (change)="jobIdSelection($event)">
                                    <mat-autocomplete #jobIdAuto="matAutocomplete" [displayWith]="displayJobIds" (optionSelected)="jobIdSelection($event)">
                                        <mat-option *ngFor="let job of filteredJobIdOptions | async" [value]="job">{{ job }} </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Facility</span></td>
                            <td>
                                <span data-qa-id="FacilityView">{{ offerDetails?.facilityName }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">AM</span></td>
                            <td>
                                <span data-qa-id="AccountManagerNameView">{{ offerDetails?.accountManagerName }}</span>
                            </td>
                        </tr>
                        <tr *ngIf="offerType === offerTypes.Direct">
                            <td><span class="label-text" data-qa-id="MarginIdLabel">Margin ID</span></td>
                            <td>
                                <span></span>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                          <ng-container>
                                <tr>
                            <td><span class="label-text">Candidate Profession</span></td>
                            <td>
                                <span data-qa-id="ProfessionView">{{ detailsFormGroup?.controls?.candidateProfessionName?.value }}</span>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td>
                        </tr>
                        <tr>
                         <td><span class="label-text">Job Profession</span></td>
                         <td>
                            <span data-qa-id="ProfessionView">{{ detailsFormGroup?.controls?.professionName?.value }}</span>
                         </td>
                        </tr>
                        <tr *ngIf="featureFlag.JobEditWorkModelAndWorkType && offerDetails?.isRemoteBooking !== null" data-qa-id="job-details-work-model">
                            <td><span class="label-text">Work Model</span></td>
                            <td>
                                <mat-radio-group formControlName="isRemoteBooking" name="isRemoteBooking" data-qa-id="job-details-work-model-radio">
                                    <mat-radio-button class="mx-2" [value]="false">On-site</mat-radio-button>
                                    <mat-radio-button class="mx-2" [value]="true">Remote</mat-radio-button>
                                </mat-radio-group>
                            </td>
                        </tr>
                        <tr *ngIf="featureFlag.JobEditWorkModelAndWorkType && offerDetails?.isPatientFacing !== null" data-qa-id="job-details-work-type">
                            <td><span class="label-text">Work Type</span></td>
                            <td>
                               <span>{{ offerDetails?.isPatientFacing ? 'Patient-facing' : 'Non Patient-facing' }}</span>
                            </td>
                        </tr>
                        <ng-container>
                            <tr *ngIf="validateCandidateProfessionJobs">
                                <td colspan="2">
                                    <mat-error>Clinician's profession must match the job's profession. Please review and update before creating
                                        an Offer.</mat-error>
                                </td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td><span class="label-text">Job Specialty</span></td>
                            <td>
                                <mat-form-field class="mc-form-field mc-form-field__shift-type--width extended-field">
                                    <mat-select formControlName="expertiseId" (selectionChange)="checkRateUpdateFields('Expertise')"
                                                [disabled]="!detailsFormGroup?.controls?.professionId?.value" data-qa-id="ExpertiseSelect">
                                        <mat-option *ngFor="let option of expertise" [value]="option.id">{{ option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>
                        </ng-container>
                        <tr><td colspan="2"></td></tr>
                        <ng-container>
                            <tr>
                                <td>
                                    <span class="label-text">Contract Length</span>
                                </td>
                                <td>
                                    <div>
                                        <mat-form-field class="contractLength">
                                            <input type="number" matInput (change)="calculateContractDates('weeksLengthChanged')"
                                                formControlName="contractLength">
                                            <mat-error>Please enter valid Weeks Length.</mat-error>
                                        </mat-form-field>
                                        <span class="label-text"> Weeks</span>
                                    </div>
                                    <div>
                                        <mat-form-field class="contractLength">
                                            <input type="number" matInput (change)="calculateContractDates('daysLengthChanged')"
                                                formControlName="contractLengthDays">
                                                <mat-error >Please enter valid Days Length.</mat-error>
                                        </mat-form-field>
                                        <span class="label-text"> Days</span>
                                        <mat-icon *ngIf="contractLengthDaysApprovalRequired" class="info-icon" [matTooltip]="contractLengthDaysInfoMessage">info</mat-icon>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">Start</span></td>
                                <td>
                                    <mat-form-field>
                                        <input matInput [matDatepicker]="picker" formControlName="startDate"
                                            (dateChange)="calculateContractDates('startDateChanged')" data-qa-id="StartDateInput">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="detailsFormGroup.controls['startDate'].invalid">Please enter valid start date.</mat-error>
                                    </mat-form-field>

                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">End</span></td>
                                <td>
                                    <mat-form-field>
                                        <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="minEndDate"
                                            (dateChange)="calculateContractDates('endDateChanged')" data-qa-id="EndDateInput">
                                        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #endPicker></mat-datepicker>
                                        <mat-error *ngIf="detailsFormGroup.controls['endDate'].invalid">Please enter valid end date.</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container>
                            <tr>
                                <td><span class="label-text">Shift Type <span>*</span></span></td>
                                <td>
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                        <mat-select formControlName="shiftTypeId" data-qa-id="ShiftTypeSelect">
                                            <mat-option *ngFor="let option of lookups?.shiftTypes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftTypeId', 'required')">Shift Type is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr>
                                <td><span class="label-text"># of Shifts <span>*</span></span></td>
                                <td [ngClass]="{'twoColTd' : viewAltShift}">
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shifts" data-qa-id="NumberShiftsSelect"
                                            (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                            <mat-option *ngFor="let num of shiftValues" [value]="num">{{ num }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shifts', 'required')"># of Shifts is required</mat-error>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="viewAltShift" class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftsAlt" data-qa-id="NumberShiftsAltSelect">
                                            <mat-option *ngFor="let num of shiftValues" [value]="num">{{ num }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftsAlt', 'required')"># of Alt Shifts is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr>
                                <td><span class="label-text">Shift Length <span>*</span></span></td>
                                <td [ngClass]="{'twoColTd' : viewAltShift}">
                                    <div class="tdSplit">
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="hours" (selectionChange)="checkRateUpdateFields('Shift Length')"
                                                        data-qa-id="ShiftLengthSelect">
                                                <mat-option *ngFor="let length of hoursValue" [value]="length">{{ length }}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="hasError('hours', 'required')">Shift Length is required</mat-error>
                                        </mat-form-field>
                                        <span class="label-text ml">Hours</span>
                                    </div>
                                    <div class="tdSplit" *ngIf="viewAltShift">
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="hoursAlt" (selectionChange)="onShiftLengthAltSelected()"
                                                        data-qa-id="ShiftAltLengthSelect">
                                                <mat-option *ngFor="let length of hoursValue" [value]="length">{{ length }}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="hasError('hoursAlt', 'required')">Alt Shift Length is required</mat-error>
                                        </mat-form-field>
                                        <span class="label-text ml">Hours</span>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span class="label-text">Shift Time of Day <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift || isRotatingShift}">
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftTimeOfDayId" (selectionChange)="checkRateUpdateFields('Shift Time of Day')"
                                                    data-qa-id="ShiftTimeSelect">
                                            <mat-option *ngFor="let option of lookups?.shiftTimes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftTimeOfDayId', 'required')">Shift Time of Day is required</mat-error>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="viewAltShift || isRotatingShift" class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftAltTimeOfDayId" data-qa-id="ShiftAltTimeSelect">
                                            <mat-option *ngFor="let option of lookups?.shiftTimes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftAltTimeOfDayId', 'required')">Alt Shift Time of Day is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span class="label-text">Shift Time</span>
                                    <span class="under-label">Optional</span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift || isRotatingShift}">
                                    <div class="tdSplit">
                                        <table class="inner-table" aria-label="shift times">
                                            <tr class="hidden">
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">Start</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftTimeStart"
                                                                      (valueChange)="onTimeStartChanged($event)" format="HH:mm"
                                                                      data-qa-id="ShiftStartTimepicker">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">End</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftTimeEnd"
                                                                      (valueChange)="onTimeEndChanged($event)" format="HH:mm"
                                                                      data-qa-id="ShiftEndTimepicker">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="tdSplit" *ngIf="viewAltShift || isRotatingShift">
                                        <table class="inner-table" aria-label="alt shift times">
                                            <tr class="hidden">
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">Start</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftAltTimeStart"
                                                                      (valueChange)="onAltTimeStartChanged($event)" format="HH:mm"
                                                                      data-qa-id="ShiftAltStartTimepicker">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text">End</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftAltTimeEnd"
                                                                      (valueChange)="onAltTimeEndChanged($event)" format="HH:mm"
                                                                      data-qa-id="ShiftAltEndTimepicker">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">Shift Details</span></td>
                                <td>
                                    <textarea formControlName="shiftDetails" class="other-notes-textarea" data-qa-id="ShiftDetailsText"></textarea>
                                </td>
                            </tr>
                        </ng-container>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">RTO</span></td>
                            <td>
                                <mat-checkbox formControlName="hasRequestedTimeOff" data-qa-id="hasRequestedTimeOffCheckbox"></mat-checkbox>
                            </td>
                        </tr>

                        <ng-container *ngIf="detailsFormGroup.controls.hasRequestedTimeOff.value">
                            <tr>
                                <td><span class="label-text">RTO Dates</span></td>
                                <td>
                                    <div class="rto-container">
                                        <div class="date-input-container">
                                            <div class="days">
                                                <span>{{ daysRequested }}</span>
                                            </div>
                                            <button class="rto-btn" mat-icon-button [matMenuTriggerFor]="appMenu">
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </div>

                                        <mat-menu #appMenu="matMenu" class="drop-calendar">
                                            <div (click)="$event.stopPropagation()">
                                                <mat-calendar #calendar class="mat-calendar" [dateClass]="dateClass()" [maxDate]="maxDate" [minDate]="minDate" (selectedChange)="dateChanged($event)"></mat-calendar>
                                            </div>
                                        </mat-menu>

                                        <a class="nova-link rto-clear__btn" [class.disabled]="daysSelected.length ?  false : true" (click)="clearDates()" #clearCalendarTrigger="matMenuTrigger" [matMenuTriggerFor]="appMenu">Clear</a>
                                    </div>
                                    <div class="offer-rto-warning">
                                        <nova-rto-warning-message [enabled]="enableRtoAlertMessageFlag() && showRTOAlertOnStartEndDates">                                      
                                        </nova-rto-warning-message> 
                                    </div>     
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">RTO Approval</span></td>
                                <ng-container>
                                    <td>
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="rtoApprovalStatus" data-qa-id="RTOApprovalStatusSelect">
                                                <mat-option [value]="1">Approved</mat-option>
                                                <mat-option [value]="2">Pending Approval</mat-option>
                                                <mat-option [value]="3">Not Approved</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Facility Rate</span></td>
                            <td>
                                <span class="label-text mr">$</span>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="facilityRate"
                                           (keyup)="updateVendorRate()" data-qa-id="FacilityRateInput"
                                           (change)="calculateContractDates('facilityRateChanged')">
                                </mat-form-field>

                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Doughboy</span></td>
                            <td>
                                <nova-recruiter-bonus [bonus]="offerDetails?.recruiterBonus" data-qa-id="DoughboyText"></nova-recruiter-bonus>
                            </td>
                        </tr>
                        <tr *ifLdFeature="featureFlag.MarginAyaPaidBonus">
                            <td><span class="label-text">Aya Paid Bonus</span></td>
                            <td>
                                <span class="label-text mr">$</span>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="ayaPaidBonus" (keydown)="validateInput($event)"
                                           data-qa-id="ayaPaidBonusInput" min="0" max="999999.99">
                                    <mat-error >Please enter valid bonus amount.</mat-error>
                                </mat-form-field>                               
                            </td>                         
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <tr *ngIf="offerType === offerTypes.Agency">
                            <td><span class="label-text">Vendor Rate</span></td>
                            <td>
                                <span class="label-text mr">$</span>
                                <mat-form-field>
                                    <input type="number" matInput formControlName="vendorRate" data-qa-id="VendorRateInput">
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Other Details</span></td>
                            <td>
                                <textarea formControlName="otherDetails" class="other-notes-textarea" data-qa-id="OtherDetailsText"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </mat-card>
        <mat-card class="notes">
        </mat-card>
    </div>
</div>
